import React from 'react';
import {
    Box,
    Typography,
    Button,
    Paper,
    Container,
    Stack
} from '@mui/material';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';

const LoggedOut = () => {
    const { login } = useKindeAuth();

    return (
        <Container maxWidth="sm">
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        borderRadius: 2,
                        width: '100%'
                    }}
                >
                    <Stack spacing={3} alignItems="center">
                        <LogoutIcon
                            sx={{
                                fontSize: 64,
                                color: 'text.secondary'
                            }}
                        />

                        <Typography variant="h4" component="h1" gutterBottom>
                            You've been logged out
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ mb: 2 }}
                        >
                            Thank you for using the CPC. You have been successfully logged out.
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<LoginIcon />}
                            onClick={() => login()}
                            sx={{
                                px: 4,
                                py: 1.5,
                                fontSize: '1.1rem'
                            }}
                        >
                            Sign In Again
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        </Container>
    );
};

export default LoggedOut;